import { CheckEnvironment, SupportedEnvironments } from '../config-global';
import { QA_DOMAIN, QA_DOMAIN_SUFFIX } from '../config';

/**
 * Determines if the current environment should use custom domain mode for authentication.
 * This is only applicable in development environments and for specific domains.
 *
 * @returns {boolean} True if custom domain mode should be used, false otherwise
 */
export const isCustomDomainMode = (): boolean => {
  if (!CheckEnvironment(SupportedEnvironments.Dev)) {
    return false; // Never in production
  }

  const hostname = window.location.hostname;

  // Only use standard flow for the main QA domain, not feature branches
  if (hostname === QA_DOMAIN) {
    return false;
  }

  // Feature branches like feat-*.guest-portal-v2.pages.dev should use custom tokens
  if (hostname.endsWith(QA_DOMAIN_SUFFIX)) {
    return true;
  }

  // Only support localhost for custom domains
  if (hostname === 'localhost' || hostname.startsWith('localhost:')) {
    return true;
  }

  // For any other custom domain, use standard flow
  return false;
};
